import React, { FC } from 'react';
import { List } from 'antd';
import classNames from 'classnames';
import { getImageNameWithoutExtensions } from '../../../../shared/Helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImage, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import styles from './Images.module.scss';
import { ImageInfo } from '../annotation.types';

type Props = {
  item: ImageInfo;
  selectedName: string;
  isPhotocardSelected: boolean;
  onListImageSelected: (name: string, isPhotocard: boolean) => void;
};

const ImageListItem: FC<Props> = ({ item, selectedName, isPhotocardSelected, onListImageSelected }) => {
  const imageClicked = () => {
    onListImageSelected(item.filename, item.isPhotocard);
  };

  const filename = item.isPhotocard ? `PC_${item.filename}` : item.filename;

  return (
    <List.Item
      className={classNames({
        'active-link-am':
          getImageNameWithoutExtensions(item.filename) === getImageNameWithoutExtensions(selectedName) && isPhotocardSelected === item.isPhotocard,
        'have-findings': item.annotationsToBeTransferredCount > 0
      })}
      onClick={imageClicked}
    >
      <FontAwesomeIcon
        icon={faFileImage}
        className={classNames(styles.photocard, {
          [styles.hidden]: !item.isPhotocard
        })}
      />
      <span>
        {filename} ({item.annotationsToBeTransferredCount}/{item.annotationsCount})
      </span>
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        className={classNames(styles.qcIssues, {
          [styles.hidden]: !item.haveQC
        })}
      />
    </List.Item>
  );
};

export default ImageListItem;
